import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const NewPasswordAsync = lazy(() => import('./ui/NewPassword'));

export const NewPassword = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <NewPasswordAsync />
    </Suspense>
  );
};
